import React from 'react';
import { IconProps } from '../types';

export const EditIcon = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#768EA7"
      d="M3.333 12.592h.943l6.21-6.209-.944-.943-6.209 6.21v.942ZM14 13.926H2v-2.829l8.957-8.956c.26-.26.682-.26.942 0l1.886 1.885c.26.26.26.683 0 .943l-7.623 7.623H14v1.334Zm-3.515-9.428.943.942.943-.942-.943-.943-.943.943Z"
    />
  </svg>
);
